import React from 'react';

const ManualPage = (props) => {
  return <div>Documentation</div>;
};

export default ManualPage;
